import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {ApiService} from "../../services/api.service";
import {GetKPISgestionJornadaResponseDTO} from "../../../dtos/response/getKPISgestionJornada.response.dto";
import {GeneralResponseDTO} from "../../../dtos/response/general.response.dto";
import {AppMessage} from "../../app.message";
import {DetalleJornadaDTO} from "../../../dtos/detalleJornada.dto";
import {GetDetalleJornadaResponseDTO} from "../../../dtos/response/getDetalleJornada.response.dto";
import {JornadaService} from "../../services/jornada.service";
import {JornadaDTO} from "../../../dtos/jornada.dto";
import moment from "moment/moment";
import {PostFinalizarViajeResquestDTO} from "../../../dtos/request/postFinalizarViaje.resquest.dto";
import {EventService} from "../../services/event.service";
import {HttpErrorResponse} from "@angular/common/http";
import {NgIf} from "@angular/common";
import {PdfDTO} from "../../../dtos/pdf.dto";
import {ToastrService} from "ngx-toastr";
import {UserService} from "../../services/user.service";

@Component({
  selector: 'app-modal-iniciar-jornada',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './modal-iniciar-jornada.component.html',
  styleUrl: './modal-iniciar-jornada.component.scss'
})
export class ModalIniciarJornadaComponent {

  public detalleJornada: DetalleJornadaDTO;
  public jornada: JornadaDTO;
  public accion: string;
  public enviando: boolean = false;

  constructor(private modalRef: BsModalRef, private apiService: ApiService, private jornadaService: JornadaService,
              private eventService: EventService, private toastr: ToastrService, private userService: UserService) {
    this.jornada = this.jornadaService.getJornadaSeleccionada();
    this.getDetalleJornada();
    this.eventService.subscribe('JORNADA_ACTUALIZADA_MQTT_EVENT', (jornada: JornadaDTO) => {
      if(jornada.uuid == this.jornada.uuid) {
        this.jornada = jornada;
        this.detalleJornada = jornada;
      }
    })
  }

  close() {
    this.modalRef.hide();
  }

  tienePermisoIniciarJornada(): boolean {
    return this.userService.tienePermiso('JORNADA_INICIAR');
  }

  muestraHora(fecha: string) {
    return moment.utc(fecha).local().format('HH:mm');
  }

  getDetalleJornada(init: boolean = false) {
    this.apiService.getDetalleJornada(this.jornada.uuid)
      .subscribe((resp) => this.getDetalleJornadaSuccess(resp), (error) => this.getDetalleJornadaError(error));
  }

  getDetalleJornadaSuccess(getDetalleJornadaResponseDTO: GetDetalleJornadaResponseDTO) {
    console.log('exito get detalle jornada', getDetalleJornadaResponseDTO);
    this.detalleJornada = getDetalleJornadaResponseDTO.data;
  }

  getDetalleJornadaError(error: HttpErrorResponse) {
    console.log('error get detalle jornada', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_DETALLE_JORNADA_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  putIniciarJornada() {
    this.enviando = true;
    this.apiService.putIniciarJornada(this.jornada.uuid)
      .subscribe(res => this.putIniciarJornadaSuccess(res), error => this.putIniciarJornadaError(error));
  }


  putIniciarJornadaSuccess(generalResponseDTO: GeneralResponseDTO) {
    console.log('put iniciar joranda success', generalResponseDTO);
    //alert(generalResponseDTO.msg);
    //this.alertService.presentAlertaInfo(generalResponseDTO.msg);
    this.getInicioJornadaPDF(generalResponseDTO.msg);
    this.eventService.publish('INICIAR_JORNADA_SUCCESS');
    //this.accion = 'POST_INICIAR';
  }

  putIniciarJornadaError(error: HttpErrorResponse) {
    console.log('put iniciar jornada error', error);
    this.enviando = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_INICIAR_JORNADA_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  getInicioJornadaPDF(msj: string) {
    this.apiService.getInicioJornadaPDF(this.jornada.uuid)
      .subscribe((resp) => this.getInicioJornadaPDFSuccess(resp, msj), (error) => this.getInicioJornadaPDFError(error));
  }

  getInicioJornadaPDFSuccess(pdfDTO: PdfDTO, msj: string) {
    console.log('exito pdf');
    this.enviando = false;
    if (pdfDTO.base64Content)
      pdfDTO.generatePdfFromBase64();
    else
      this.toastr.success(`${msj}`, 'Éxito', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
      //this.toastr.success(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`, 'Éxito');
    this.close();
  }

  getInicioJornadaPDFError(error: HttpErrorResponse) {
    console.log('error kpis', error);
    this.enviando = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_PDF_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

}
